<template>
  <footer class="footer bg-light mt-5">
    <div class="container py-7">
      <div class="row">
        <div class="col-12 col-md col-lg-6">
          <div class="row justify-content-center justify-content-md-start">
            <img class="footer-logo" src="@/assets/icons/logos/logo-sungevity-engie-color.svg" />
          </div>
        </div>
        <div class="col-12 col-md mt-2">
          <div class="pb-5 text-center text-md-left" v-for="line in legalLines" :key="line">
            <span>{{ line }}</span>
          </div>
          <template v-if="!content.footer_legal_lines">
            <div class="pb-5 text-center text-md-left">
              <!-- Unfortunatly this is hardcoded this due to time constraints.
              Preferrable the content would be management with a content management service like Odoo / Phrase -->
              <a v-if="isB2b" class="social-inner" href="mailto:huurdak@sungevity.nl">
                <span>huurdak@sungevity.nl</span>
              </a>
              <a v-else class="social-inner" :href="`mailto:${content.footer_email_link}`">
                <span v-dynamic-content:footer_email></span>
              </a>
            </div>
            <div class="pb-5 text-center text-md-left">

              <a v-if="isB2b" class="social-inner" href="http://www.sungevity.nl/huurdak" target="_blank">
                <span>www.sungevity.nl/huurdak</span>
              </a>
              <a v-else class="social-inner" :href="content.footer_website_link" target="_blank">
                <span v-dynamic-content:footer_website></span>
              </a>

            </div>
            <div class="pb-5 text-center text-md-left">
              <a class="social-inner" :href="`tel:${content.footer_phone_link}`">
                <span v-dynamic-content:footer_phone></span>
              </a>
            </div>
          </template>
        </div>
        <div v-if="!isB2b" class="col-12 col-md">
          <div class="d-flex mb-5 justify-content-center justify-content-md-start">
            <div class="mr-1">
              <a :href="content.footer_social_facebook_link" target="_blank">
                <img src="@/assets/icons/social/Facebook.svg" />
              </a>
            </div>
            <div class="mr-1">
              <a :href="content.footer_social_linkedin_link" target="_blank">
                <img src="@/assets/icons/social/Linkedin.svg" />
              </a>
            </div>
          </div>
          <div class="pb-5 text-center text-md-left">
            <a class="social-inner" :href="content.footer_privacy_link" target="_blank">
              <span v-dynamic-content:footer_privacy></span>
            </a>
          </div>
          <div class="pb-5 text-center text-md-left">
            <a class="social-inner" :href="content.footer_conditions_link" target="_blank">
              <span v-dynamic-content:footer_conditions></span>
            </a>
          </div>
          <div class="pb-5 pt-7 text-center text-md-left">
            <span class="social-inner" v-dynamic-content:footer_copyright></span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    legalLines() {
      const lines = this.$store.getters.content.footer_legal_lines

      if (lines) return lines.trim().split('\n')
      else return []
    },
    isB2b() {
      return !this.$route.path.startsWith('/iquote')
    },
  }
}
</script>
